import React, { Component } from 'react';
import Section from '../../layout/Section';
import image from '../../assets/img/vector/infraestructura.svg';
import SectionContainer from '../../subcomponents/SectionContainer';
import ImageText from '../../subcomponents/ImageText';
import TextImage from '../../subcomponents/TextImage';
import imgBody1 from '../../assets/img/infraestructura.jpg';
import img1 from '../../assets/img/flat/infraestructura1.svg';
import img2 from '../../assets/img/flat/infraestructura2.svg';
import img3 from '../../assets/img/flat/infraestructura3.svg';
import IconBlock from '../../subcomponents/IconBlock28';
import cisco from '../../assets/logo/cisco.png';
import ubiquiti from '../../assets/img/brand/ubiquiti.png';
import fortinet from '../../assets/img/brand/fortinet.png';
import mikrotik from '../../assets/img/brand/mikrotik.png';
import leviton from '../../assets/img/brand/leviton.png';

class InfraestructuraRed extends Component {
  componentDidMount() {
    document.title = 'Infraestructura de Red - Insacom';
  }

  render() {
    const content = [
      {
        id: 1,
        title: 'Escalabilidad',
        description: 'Diseñamos redes escalables que se adaptes a nuevos escenarios',
        img: img1
      },
      {
        id: 2,
        title: 'Servicio Completo',
        description:
          'Desde el diseño, cableado, configuración, puesta en marcha, operación y mantenimiento',
        img: img2
      },
      {
        id: 3,
        title: 'Confiable',
        description: 'Una red robusta para que su negocio pueda crecer sin interrupciones',
        img: img3
      }
    ];

    const descripcion =
      'Diseñamos e implementamos proyectos de infraestructura de red integrales para mantener conectada a su empresa. Contamos con especialización en redes cableadas e inalámbricas para adaptarnos a todas sus necesidades.';

    return (
      <Section asuntoContacto={'Infraestructura de Red'}>
        <SectionContainer grey paddingBottom={0} paddingTop={100}>
          <ImageText image={image} title="Infraestructura de Red" description={descripcion}>
            <div className="d-flex justify-content-around flex-wrap">
              <div className="align-self-center p-2">
                <img src={mikrotik} alt="Mikrotik" style={{ height: '40px' }}></img>
              </div>
              <div className="align-self-center p-2">
                <img src={ubiquiti} alt="Ubiquiti" style={{ height: '60px' }}></img>
              </div>
              <div className="align-self-center p-2">
                <img src={fortinet} alt="Fortinet" style={{ height: '45px' }}></img>
              </div>
            </div>
            <div className="d-flex justify-content-around flex-wrap mt-2">
              <div className="align-self-center p-2">
                <img src={cisco} alt="Cisco" style={{ height: '60px' }}></img>
              </div>
              <div className="align-self-center p-2">
                <img src={leviton} alt="Leviton" style={{ height: '50px' }}></img>
              </div>
            </div>
          </ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock version={1} content={content}></IconBlock>
        </SectionContainer>
        <SectionContainer grey>
          <TextImage
            image={imgBody1}
            title="Características"
            description="Más del 90% de los problemas comunes en la red son asociados a una red física
              deficiente. Minimice las fallas con instalaciones certificadas, y construidas por
              expertos.">
            <ul className="list-unstyled mb-0 mt-4">
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Diseño de Ingeniería basado en normas Chilenas y mejores prácticas
                  internacionales.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Redes cableadas e inalámbricas.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Instalación, configuración y puesta en marcha de equipamiento.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Trabajamos con las mejores marcas del mercado.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Instalaciones certificadas.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Redes LAN empresariales.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  WiFi.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  HotSpot.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Cobertura Inalámbrica para bodegas e instalaciones industriales.
                </p>
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
      </Section>
    );
  }
}

export default InfraestructuraRed;



// WEBPACK FOOTER //
// ./src/sections/proyectos/InfraestructuraRed.js